import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/actions/configuration/rootReducer';
import { ExternalSource } from 'src/actions/integrations/integrationSources';
import integrationsResource from 'src/actions/integrations/integrationsResource';
import useResource from 'src/presentation/hooks/useResource';
import LookupDebuggerPageLayout from './LookupDebuggingPageLayout';
import lookupDebuggerAutolinkingResource from 'src/actions/integrations/lookupAdapterDebugging/lookupDebuggerAutolinkingResource';
import AutolinkingDebuggingResults from './AutolinkingDebuggingResults';
import { DebugFlowType } from './SearchPanel';

const AutolinkingDebugger: FC = () => {
  const orgId = useSelector((state: RootState) => state.auth.orgId);
  const [currentApp, setCurrentApp] = useState<ExternalSource>();
  const dispatch = useDispatch();
  const workFlowTitle = 'Test Autolinking + Detailed Workflow';
  const { values: allIntegrations, loadingState: integrationLoadingState } = useResource(integrationsResource);

  const [enabledIntegrations, setEnabledIntegrations] = useState<ExternalSource[]>([]);

  useEffect(() => {
    const enabledIntegrations = allIntegrations.filter(
      integration => integration.enabled && integration.customerLookupSettings
    );
    setEnabledIntegrations(enabledIntegrations);
  }, [allIntegrations, dispatch]);

  const unloadResources = () => {
    dispatch(lookupDebuggerAutolinkingResource.effects.unload());
  };

  const onSubmit = formValues => {
    const searchEmail = formValues.queryAttr['searchEmail'];
    const searchPhone = formValues.queryAttr['searchPhone'];

    dispatch(
      lookupDebuggerAutolinkingResource.effects.fetchAutolinkingDebugging(
        { orgId: orgId, integrationId: formValues.appId },
        {
          searchEmail,
          searchPhone,
        }
      )
    );

    const currentApp = enabledIntegrations.find(app => app.id === formValues.appId);
    setCurrentApp(currentApp);
  };

  return (
    <LookupDebuggerPageLayout
      onSubmit={onSubmit}
      enabledIntegrations={enabledIntegrations}
      integrationLoadingState={integrationLoadingState}
      currentApp={currentApp}
      flowType={DebugFlowType.AUTOLINKING}
      unloadResources={unloadResources}
      workFlowTitle={workFlowTitle}
      data-aid="admin-autolinking-debugger-page-modal"
    >
      <AutolinkingDebuggingResults />
    </LookupDebuggerPageLayout>
  );
};

export default AutolinkingDebugger;
